/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PutApiAuthorsIdMutationRequest, PutApiAuthorsIdMutationResponse, PutApiAuthorsIdPathParams, PutApiAuthorsId400, PutApiAuthorsId401, PutApiAuthorsId403, PutApiAuthorsId404, PutApiAuthorsId500 } from "../../types/PutApiAuthorsId.ts";
import { putApiAuthorsIdMutationResponseSchema, putApiAuthorsIdMutationRequestSchema } from "../../zod/AuthorSchemas/putApiAuthorsIdSchema.ts";

function getPutApiAuthorsIdUrl({ id }: { id: PutApiAuthorsIdPathParams["Id"] }) {
  const res = { method: 'PUT', url: `/api/authors/${id}` as const }  
  return res
}

/**
 * @summary Метод редактирования автора.
 * {@link /api/authors/:Id}
 */
export async function putApiAuthorsId({ id, data }: { id: PutApiAuthorsIdPathParams["Id"]; data?: PutApiAuthorsIdMutationRequest }, config: Partial<RequestConfig<PutApiAuthorsIdMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = putApiAuthorsIdMutationRequestSchema.parse(data)  
  
  const res = await request<PutApiAuthorsIdMutationResponse, ResponseErrorConfig<PutApiAuthorsId400 | PutApiAuthorsId401 | PutApiAuthorsId403 | PutApiAuthorsId404 | PutApiAuthorsId500>, PutApiAuthorsIdMutationRequest>({ method : "PUT", url : getPutApiAuthorsIdUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return putApiAuthorsIdMutationResponseSchema.parse(res.data)
}